import { render, staticRenderFns } from "./pay-widget.vue?vue&type=template&id=d87641f6&"
import script from "./pay-widget.vue?vue&type=script&lang=js&"
export * from "./pay-widget.vue?vue&type=script&lang=js&"
import style0 from "./pay-widget.vue?vue&type=style&index=0&id=d87641f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports